import { useEffect } from 'react';

const Analytics = () => {
  useEffect(() => {
    // Create and append the gtag script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17057632150';
    document.head.appendChild(script1);

    // Create and append the gtag configuration script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17057632150');
    `;
    document.head.appendChild(script2);

    // Meta Pixel Code
    const script3 = document.createElement('script');
    script3.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1445792686576059');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script3);

    // Meta Pixel noscript fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1445792686576059&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);

    console.log('Google Analytics and Meta Pixel scripts loaded');

    // Cleanup function to remove scripts when component unmounts
    return () => {
      if (document.head.contains(script1)) document.head.removeChild(script1);
      if (document.head.contains(script2)) document.head.removeChild(script2);
      if (document.head.contains(script3)) document.head.removeChild(script3);
      if (document.head.contains(noscript)) document.head.removeChild(noscript);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default Analytics;
